import React, {useEffect, useState} from 'react';
import {Button} from "react-bootstrap";
import ManateeDropdown from "../ManateeDropdown";
import {toastr} from "react-redux-toastr";


const formatFolderName = (folderName) => (folderName.length < 25 ? folderName : folderName.substring(0, 22) + '...');

const FolderDropdownBtn = ({toggle_dropdown, trigger_props}) => (
    <Button className="select-folder-btn" onClick={() => toggle_dropdown()}
            style={{'marginRight': '5px', outline: 'none', cursor: 'pointer'}}>
        <span
            className="select-folder-text-container">{trigger_props.selectedFolder ? formatFolderName(trigger_props.selectedFolder.name) : "Select a folder"}</span>
    </Button>
);

const createDesignFolder = ({folder_name}) => {
    const url = global.config.server_path + 'folder/create';
    return fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        'credentials': 'include',
        'body': JSON.stringify({'folder_name': folder_name, 'folder_type': 'design'})
    })
        .then(resp => resp.json())
        .catch(err => {
            console.error(err);
            toastr.error("Something went wrong :/");
        })
};

const FolderDropdownMenu = ({dropper_props, toggle_dropdown}) => {

    const [activeTab, setActiveTab] = useState("folders");
    const [folderName, setFolderName] = useState("");

    switch (activeTab) {
        case "folders":
            return (
                <div>
                    <div>
                        <ul className="select-folder-dropdown thin_scroll">
                            {
                                dropper_props.folders.map((folder, id) => {
                                    return (
                                        <li key={"select-folder-dropdown-li-" + id}
                                            className="select-folder-dropdown-item" onClick={(e) => {
                                            dropper_props.setSelectedFolder(folder.folder);
                                            toggle_dropdown();
                                        }}>
                                <span
                                    className="toolbar-dropdown-text">{formatFolderName(folder.folder.name)}</span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    <hr className="folder-dropdown-separator"/>
                    <div>
                        <Button className="folder-dropdown-add-folder" onClick={() => setActiveTab("add_folder")}>
                            <span className="fa fa-plus"/>
                            {/*<img
                                src={global.config.static_file_server_path + "uploads/icons/plus-circle-fill copy.svg"}/>*/}
                            <span className="folder-dropdown-add-folder-text">New folder</span>
                        </Button>
                    </div>
                </div>
            );
        case "add_folder":
            return (
                <div className="folder-dropdown-add-folder-home">
                    <div style={{width: '100%', paddingTop: 8, paddingLeft: 8}}>
                        <i className="fas fa-chevron-left" style={{cursor: 'pointer'}} onClick={() => {
                            setActiveTab("folders");
                            setFolderName("");
                        }}/>
                    </div>
                    <div style={{width: '100%', padding: 8}}>
                        <input className="add-folder-input-field" placeholder="Enter a folder name" value={folderName}
                               onChange={(e) => setFolderName(e.target.value)}/>
                    </div>
                    <div style={{padding: 8}}>
                        <Button onClick={async () => {
                            try{
                                setActiveTab("folders")
                                setFolderName("");
                                toggle_dropdown();
                                await createDesignFolder({folder_name: folderName})
                                dropper_props.fetchFolders();
                            }catch(e){
                                console.log(e);
                            }
                        }} className="folder-dropdown-add-folder create-folder-btn" disabled={folderName === ""}>Create</Button>
                    </div>
                </div>
            );
        default:
            return <div/>
    }

};

const FolderDropdown = ({folders, selectedFolder, fetchFolders, setSelectedFolder}) => {
    return (
        <div>
            <ManateeDropdown
                Trigger={FolderDropdownBtn}
                Dropper={FolderDropdownMenu}
                dropper_props={{setSelectedFolder: setSelectedFolder, folders: folders, fetchFolders: fetchFolders}}
                trigger_props={{selectedFolder: selectedFolder}}
                dropper_container_style={{'left': 0, 'top': 40}}
            />
        </div>
    );
};

export default FolderDropdown;